import _ from 'underscore';
import { get, set } from '@bingads-webui-universal/primitive-utilities';

const biPattern = /^(Phone)?PerformanceMetrics\//;
const isBiColumn = (column) => {
  let key;

  if (_.isString(column.property)) {
    key = column.property;
  } else if (column.property) {
    ({ key } = column.property);
    key = _.isArray(key) && key.length > 0 ? key[0] : key;
  }

  return biPattern.test(key);
};

const appendSegmentFlag = (property) => {
  if (_.isFunction(property)) {
    return model => ({
      IsSegmentRow: model.IsSegmentRow,
      property: {
        value: property(model),
      },
    });
  } else if (_.isObject(property) && _.isFunction(property.get)) {
    return _.defaults({
      get: model => ({
        IsSegmentRow: model.IsSegmentRow,
        property: {
          value: property.get(model),
        },
      }),
    }, property);
  } else if (_.isString(property)) {
    return {
      get: model => ({
        IsSegmentRow: model.IsSegmentRow,
        property: {
          value: get(model, property.replace(/\//g, '.')),
        },
      }),
      key: property,
    };
  }

  throw new Error('unknown property type.');
};

const segmentConfig = [{
  segArray: 'PerformanceMetrics.SegmentedData',
  from: 'Key[0].StringValue',
  to: 'SegmentValue',
}, {
  segArray: 'PerformanceMetrics.SegmentedData',
  from: 'Key[0].SegmentationType',
  to: 'SegmentationType',
}, {
  segArray: 'PerformanceMetrics.SegmentedData',
  from: 'Data',
  to: 'PerformanceMetrics',
}, {
  segArray: 'PeriodPerformanceMetrics.SegmentedData',
  from: 'Data',
  to: 'PeriodPerformanceMetrics',
}, {
  segArray: 'PerformanceMetricsChange.SegmentedData',
  from: 'Data',
  to: 'PerformanceMetricsChange',
}, {
  segArray: 'PerformanceMetricsChangePercentage.SegmentedData',
  from: 'Data',
  to: 'PerformanceMetricsChangePercentage',
}, {
  segArray: 'PhonePerformanceMetrics.SegmentedData',
  from: 'Data',
  to: 'PhonePerformanceMetrics',
}, {
  segArray: 'PhonePeriodPerformanceMetrics.SegmentedData',
  from: 'Data',
  to: 'PhonePeriodPerformanceMetrics',
}, {
  segArray: 'PhonePerformanceMetricsChange.SegmentedData',
  from: 'Data',
  to: 'PhonePerformanceMetricsChange',
}, {
  segArray: 'PhonePerformanceMetricsChangePercentage.SegmentedData',
  from: 'Data',
  to: 'PhonePerformanceMetricsChangePercentage',
}];

function isAggregateRow(row) {
  return !!(_.result(row.item, '$total', false) || _.result(row.item, 'AggregateName', false));
}

export default {
  name: 'segment',
  handler: function segment(state, { expandedAggregate = [] } = {}) {
    const columns = _.map(state.columns, (column) => {
      if (isBiColumn(column)) {
        return column;
      }

      return _.defaults({
        property: appendSegmentFlag(column.property || column.name),
        template: (prop) => {
          if (prop.value.IsSegmentRow) {
            return ' ';
          }

          return _.isFunction(column.template) ? column.template(prop.value.property) : undefined;
        },
      }, column);
    });

    const bodyRows = _.reduce(state.bodyRows.slice(), (memo, row) => {
      let result = memo;
      const r = _.extend({}, row);

      const segs = _.reduce(segmentConfig, (m, { segArray, from, to }) => {
        const toSeg = get(row.item, segArray);
        const rowType = _.result(row.item, '$total', {}).type;
        const segsInRow = m.slice();

        if (toSeg && toSeg.length > 0) {
          if (!isAggregateRow(row) ||
            _.contains(expandedAggregate, rowType || row.item.AggregateName)) {
            _.each(toSeg, (obj, index) => {
              segsInRow[index] = segsInRow[index] || {};
              segsInRow[index].classes = segsInRow[index].classes || r.classes || [];
              segsInRow[index].item = segsInRow[index].item || {};
              set(segsInRow[index].item, to, get(obj, from));
              segsInRow[index].item.IsSegmentRow = true;
            });
          }

          r.item = _.defaults({
            HasSegmentRow: true,
          }, r.item);
        }

        return segsInRow;
      }, []);

      result = result.concat(r);
      result = result.concat(segs);
      return result;
    }, []);

    return _.defaults({ bodyRows, columns }, state);
  },
  defaults: {},
};
